import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation, Trans } from "react-i18next";
import {useHistory, useRouteMatch} from "react-router";

import {movePostsApi, moveSelectPostsApi} from "actions/post.action";

import { NORMAL, PHOTO, UCC } from "constant/board";
import { JAVASCRIPT_VOID } from "constant/config";

import SelectBox from "components/SelectBox";
import useLocationParams from "components/hook/useLocationParams";

const PostMove = ({ close, top, left, right, titleNo, oldBbsNo }) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const history = useHistory();
	const match = useRouteMatch();

	// url query parameter
	const { param, search, historyParams } = useLocationParams();

	// 이동할 게시판 번호
	const [bbsNo, setBbsNo] = useState(0);

	// 이동 가능한 게시판 리스트
	const options = useSelector(({ stationReducer }) => {
		const { stationInfo = {} } = stationReducer;
		const { data = {} } = stationInfo;
		const { station = {} } = data;
		const { menus = [] } = station;

		const options = menus
			.filter((menu) => [NORMAL, PHOTO, UCC].includes(menu.display_type))
			.map((menu) => ({
				value: menu.bbs_no,
				name: menu.name,
			}));

		options.unshift({
			value: 0,
			name: t("게시판을 선택하세요."),
		});

		return options;
	});

	// 팝업 이벤트 전달 막기
	const handleStopEvent = (event) => {
		event.stopPropagation();
		event.nativeEvent.stopImmediatePropagation();
	};

	// 이동할 게시판 선택
	const handleSelectBoard = (bbsNo) => {
		setBbsNo(bbsNo);
		//alert(t("[공개설정] 변경 시 비공개 영상과 구독 VOD 영상은 변경된 게시판의 권한으로 자동 수정됩니다."));
		try {
			// 게시글에 UCC 영상이 있는지 확인 후 영상 타입 별 선택한 게시판 이동 권한 체크
			dispatch(moveSelectPostsApi(titleNo, bbsNo, oldBbsNo));

		} catch (error) {}

	};

	// 팝업 닫기
	const handleClosePopup = () => {
		close();
	};

	// 게시판 이동
	const handleSubmit = useCallback(async () => {
		if (bbsNo === 0) {
			return;
		}

		try {
			await dispatch(movePostsApi(titleNo, bbsNo, oldBbsNo));

			// replace 조건 변경
			history.replace(match.url + search);
			//history.replace({ state: { bbs_no: bbsNo } });
			//window.location.reload();
		} catch (error) {}

		close();
	}, [bbsNo, close, dispatch, history, oldBbsNo, titleNo]);

	return (
		<div className="ui-pop layer_move-bbs active" style={{ position: "absolute", top, left, right }} onClick={handleStopEvent}>
			<p className="pop-title">
				<Trans>게시글 이동</Trans>
			</p>
			<div className="pop-body">
				<SelectBox options={options} value={bbsNo} onChange={handleSelectBoard} stopPropagation={true} />
			</div>
			<div className="pop-btn line">
				<button type="button" className="btn-basic blue" onClick={handleSubmit}>
					<span>
						<Trans>확인</Trans>
					</span>
				</button>
				<button type="button" className="btn-basic" onClick={handleClosePopup}>
					<span>
						<Trans>취소</Trans>
					</span>
				</button>
			</div>
			<a href={JAVASCRIPT_VOID} className="pop-close" onClick={handleClosePopup}>
				<span>
					<Trans>닫기</Trans>
				</span>
			</a>
		</div>
	);
};

export default PostMove;
